/** Types */
export const CREATE_FAVOR = "CREATE_FAVOR";
export const EDIT_FAVOR = "EDIT_FAVOR";
export const DELETE_FAVOR = "DELETE_FAVOR";
export const GET_FAVORS = "GET_FAVORS";
export const GET_FAVORS_SUCCESS = "GET_FAVORS_SUCCESS";

export const GET_FAVORS_FOR_FILTER = "GET_FAVORS_FOR_FILTER";
export const GET_FAVORS_FOR_FILTER_SUCCESS = "GET_FAVORS_FOR_FILTER_SUCCESS";
